import { createFileRoute } from '@tanstack/react-router'
import SetupPasswordPage from '@/spa/pages/SetupPasswordPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/setup-password')({
  component: SetupPasswordPage,
  errorComponent: routeErrorComponent,
})
